<!-- eslint-disable -->
<template lang="pug">
    .map(id="map-wrapper" v-if="user.type !== 'olympiads-student'")
        portal(to="mapProgress")
            .nav-progress
                .nav-item
                    map-progress(@changeContinent="changeContinent")
        .map-buttons-container
            .map-icon(
                 @click="isContinentsModalShown = true"
                 :title="$i18n.t('map.map_button_chooseContinentTitle')"
            )
                img.continents-img(:src="ContinentsImage")
            .map-icon(
                 @click="isSubmarineShown = true"
                 v-if="showSubmarine"
                 :title="$i18n.t('map.map_button_submarineTitle')"
            )
                img.submarine-img(:src="SubmarineImage")
            .map-icon(
                @click="openFinalVideoModal"
                v-if="showFinalVideoIcon"
                :title="$i18n.t('map.map_button_finalVideoTitle')"
            )
                img.final-video-img(:src="FinalVideoImage")
        continent-picker(
            :continent="continent"
            :displayModal="isContinentsModalShown"
            :availableContinents="availableContinents"
            @open="isContinentsModalShown = true"
            @close="isContinentsModalShown = false"
            @changeContinent="changeContinent(arguments[0]); isContinentsModalShown = false"
        )
        submarine(
            :displayModal="isSubmarineShown"
            @open="isSubmarineShown = true"
            @close="isSubmarineShown = false"
        )
        transition(name="fade")
            final-video-modal(
                v-if="isFinalModalActive && !isModalActive"
                @close="closeFinalVideoModal"
            )
        transition(name="fade")
            conversation-modal(
                @close="closeConversationModalHandler"
                v-if="isModalActive"
                :cityName="selectedCity"
                :isMobile="isMobile"
                :isFirstTime="isFirstTime"
                @isFirstTime="isFirstTime = true"
                @changeContinent="changeContinent"
            )
        .warning
            svg(
                version="1.1" id="rotate" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                width="40px" height="40px" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;"
                xml:space="preserve"
            )
                rotation-icon
            div
                | {{ $i18n.t('map.map_mobile_rotateText') }}
        .for-landscape
            svg.main-svg(
                xmlns="http://www.w3.org/2000/svg"
                id="map"
                :style="svgStyle"
            )
                land(:continent="continent")
                main-points(
                    :availableCities="availableCities"
                    :zoomEnded="zoomEnded"
                    :panEnded="panEnded"
                    :continent="continent"
                    @openModal="openModal"
                    @disableActions="disableMap"
                    @transition="panTo"
                )
            svg.compass(
                 xmlns="http://www.w3.org/2000/svg"
                 x="0px"
                 y="0px"
                 width="120px"
                 height="120px"
                 v-once
            )
                compass
            .navigation-buttons
                button.button(
                    v-if="user.type === 'student'"
                    :class="isDisabled && 'is-disabled'"
                    @click="zoomAtLocation(user.mapLocation.name)"
                    :title="$i18n.t('map.map_button_myLocationTitle')"
                )
                    i.fa.fa-location-arrow(aria-hidden="true")
                button.button(
                    :class="(isMobile || isDisabled) && 'is-disabled'"
                    @click="resize"
                    :title="$i18n.tc('map.map_button_resizeTitle', isFullScreen ? 1 : 2)"
                )
                    i.fa(:class="isFullScreen ? 'fa-compress' : 'fa-expand'" aria-hidden="true")
                button.button(
                    :class="(isZoomInDisabled || isDisabled) && 'is-disabled'",
                    @click="map.zoomIn()",
                    :title="$i18n.t('map.map_button_closerTitle')"
                )
                    i.fa.fa-plus(aria-hidden="true")
                button.button(
                    :class="(isZoomOutDisabled || isDisabled) && 'is-disabled'",
                    @click="map.zoomOut()",
                    :title="$i18n.t('map.map_button_awayTitle')"
                )
                    i.fa.fa-minus(aria-hidden="true")
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import Land from './map-assets/Map.vue'
    import MainPoints from './MainPoints.vue'
    import Compass from './map-assets/Compass.vue'
    import cities from '../../../config/cities.json'
    import continentsList from '../../../config/continentsList.json'
    import continents from '../../../config/continents'
    import RotationIcon from './map-assets/RotationIcon.vue'
    const ConversationModal = () => import('../modals/map/Conversation.vue')
    import svgPanZoomMixin from '../../../utils/map/svgPanZoomMixin'
    import Submarine from './Submarine.vue'
    import ContinentPicker from './ContinentPicker.vue'
    import MobileDetect from 'mobile-detect/mobile-detect.js'
    import {getPreviousLocation} from '../../../utils/map/getPreviousLocation'
    import MapProgress from './Progress.vue'

    import ContinentsImage from '../../../assets/images/map/continents.png'
    import SubmarineImage from '../../../assets/images/map/Submarine.png'
    import FinalVideoImage from '../../../assets/images/map/finalVideo.png'

    import FinalVideoModal from "../modals/map/FinalVideo";

    export default {
        props: {
            modal: {
                type: Boolean,
                default: false
            },
            video: {
                type: Boolean,
                default: false
            },
            location: String
        },
        components: {
            Land,
            MainPoints,
            Compass,
            RotationIcon,
            ConversationModal,
            FinalVideoModal,
            Submarine,
            ContinentPicker,
            MapProgress
        },
        mixins: [svgPanZoomMixin],
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            availableCities() {
                return cities.filter((elem, index) => this.user.availableLocationId - 1 > index);
            },
            showSubmarine() {
                return this.user.availableLocationId - 1 > cities.indexOf('Tokyo')
            },
            showFinalVideoIcon() {
                return this.user.availableLocationId  - 1 > cities.indexOf('Venus');
            },
            availableContinents() {
                if (this.user.availableLocationId - 1 > cities.length) {
                    return this.continentsList;
                }

                let continentIndex = this.continentsList.indexOf(
                    this.continents[cities[this.user.availableLocationId - 2]]
                );
                return this.continentsList.filter((continent, index) => {
                    return index <= continentIndex;
                });
            },
            svgHeight() {
                if (this.isMobile || this.isFullScreen) {
                    return '100vh';
                }
                return 'calc(100vh - 155px)';
            },
            svgStyle() {
                let width = '100%';
                let height = this.svgHeight;
                if (this.continent === 'Space'){
                    return {width: width, height: height, background: 'rgb(18, 85, 160)'};
                }
                return {width: width, height: height};
            }
        },
        watch: {
            availableCities: {
                handler(val) {
                    this.addHandlers();
                },
                deep: true
            },
            isFullScreen(val) {
                let mainColumnClassList = document.getElementsByClassName('main-column')[0].classList;
                val ? mainColumnClassList.add('is-fullscreen') : mainColumnClassList.remove('is-fullscreen');
            },
            '$root.sidebar'(val) {
                if (window.innerWidth > 999 && this.map) {
                    this.map.center();
                }
            },
            map: {
                handler() {
                    if (!this.isMobile) {
                        document.addEventListener('mousedown', this.disableEvents);
                        document.addEventListener('mouseup', this.limitPan);
                    }
                }
            },
            isModalActive(val) {
                this.disablePan(val);
            },
            isSubmarineShown(val) {
                this.disablePan(val);
            },
            isContinentsModalShown(val) {
                this.disablePan(val);
            },
            '$root.continentTransition'(val) {
                if (val) {
                    this.openModal();
                }
            }
        },
        data() {
            return {
                map: null,
                scale: 3.5,
                cityPositions: {},
                isModalActive: false,
                isFinalModalActive: false,
                firstTime: true,
                isFullScreen: false,
                isZoomOutDisabled: false,
                isZoomInDisabled: false,
                isMobile: false,
                selectedCity: null,
                isModalDisabled: false,
                zoomEnded: false,
                panEnded: false,
                isDisabled: false,
                isFirstTime: false,
                disablePanEvents: false,
                animateInterval: null,
                continent: 'Eurasia',
                extraWidth: 500,
                extraHeight: 500,
                continents,
                continentsList,
                isSubmarineShown: false,
                isContinentsModalShown: false,
                isPanEnabled: true,
                ContinentsImage,
                SubmarineImage,
                FinalVideoImage,
                isSetOnClickForCity: false
            }
        },
        methods: {
            closeConversationModalHandler() {
                this.handleFinal();

                this.isModalActive = false;
                this.selectedCity = null;
                this.isFirstTime = false;
                this.panEnded = true;
                this.isModalDisabled = false;
                this.isDisabled = false
            },
            openFinalVideoModal() {
                this.isFinalModalActive = true;
                this.isPanEnabled = false;
            },
            closeFinalVideoModal() {
                this.isFinalModalActive = false;
                this.isPanEnabled = true;
            },
            handleFinal() {
                if (this.isFirstTime && this.user.mapLocation.nextCity === this.$lastMapAvailableLocation) {
                    setTimeout(() => {
                        this.isFinalModalActive = true;
                    }, 800);
                }
            },
            changeContinent(continent) {
                return new Promise(resolve => {
                    this.continent = continent;
                    this.$nextTick(() => {
                        if (this.map) {
                            this.map.updateBBox();
                            this.map.fit();
                            this.map.center();
                        }
                        this.addHandlers();
                        resolve();
                    });
                });
            },
            disablePan(status) {
                if (!this.map) {
                    return;
                }
                this.isPanEnabled = !status;
                if (status) {
                    this.map.disablePan();
                } else {
                    this.map.enablePan();
                }
            },
            limitPan() {
                if (!this.map) {
                    return;
                }
                this.disablePanEvents = false;
                let pan = this.map.getPan();
                if (!pan) {
                    return;
                }
                if (isNaN(pan.x) || isNaN(pan.y)) {
                    return;
                }
                let sizes = this.map.getSizes();
                let svg = document.querySelector('.svg-pan-zoom_viewport');
                if (!svg) {
                    return;
                }
                let clientRect = svg.getBoundingClientRect();
                let leftBorder = -sizes.realZoom * (sizes.viewBox.x - this.extraWidth);
                let topBorder = -sizes.realZoom * (sizes.viewBox.y - this.extraHeight);
                let rightBorder =
                    -sizes.realZoom * (sizes.viewBox.x + this.extraWidth) - clientRect.width + sizes.width;
                let bottomBorder =
                    -sizes.realZoom * (sizes.viewBox.y + this.extraHeight) - clientRect.height + sizes.height;
                let customPan = {};
                customPan.x = Math.min(leftBorder, Math.max(rightBorder, pan.x));
                customPan.y = Math.min(topBorder, Math.max(bottomBorder, pan.y));
                this.map.pan(customPan);
            },
            disableEvents() {
                if (!this.isSetOnClickForCity) {
                    this.addHandlers();
                }
                this.disablePanEvents = true;
            },
            zoomTo(zoom, element) {
                return new Promise(resolve => {
                    this.disableActions();
                    this.animatedZoomTo(zoom, element)
                        .then(() => {
                            this.enableActions();
                            resolve();
                        });
                });
            },
            panTo(element, previousElement) {
                if (this.map) {
                    this.panEnded = false;
                    this.animatedPanTo(element, previousElement)
                        .then(() => {
                            this.panEnded = true;
                        });
                }
            },
            disableMap(status) {
                this.isModalDisabled = status;
                if (status) {
                    this.disableActions();
                    let prevLocation = getPreviousLocation(this.user.mapLocation.name);
                    let locationForZoom = continents[prevLocation] !== continents[this.user.mapLocation.name] ?
                        this.user.mapLocation.name : prevLocation;
                    this.animatedZoomTo(
                        this.scale,
                        document.getElementById(locationForZoom)
                    ).then(() => {
                        this.zoomEnded = true;
                    });
                } else {
                    this.enableActions();
                    this.zoomEnded = false;
                }
            },
            disableActions() {
                this.isDisabled = true;
                this.$root.isNextCityDisabled = true;
                this.isModalDisabled = true;
                if (this.map) {
                    this.map.disableZoom();
                    this.map.disableMouseWheelZoom();
                    this.map.disableDblClickZoom();
                    this.map.disablePan();
                }
            },
            enableActions() {
                this.isDisabled = false;
                this.$root.isNextCityDisabled = false;
                this.isModalDisabled = false;
                this.map.enableZoom();
                this.map.enableMouseWheelZoom();
                this.map.enableDblClickZoom();
                this.map.enablePan();
            },
            animatedZoomTo(zoom, element) {
                return new Promise(resolve => {
                    let animationTime = 600;
                    let svg = document.querySelector('.svg-pan-zoom_viewport');
                    if (svg && this.map) {
                        svg.style.transition = `transform ${animationTime / 1000}s ease`;
                        this.map.zoom(zoom);
                        this.map.pan(this.getElementPosition(element));
                        setTimeout(() => {
                            svg.style.transition = '';
                            resolve();
                        }, animationTime);
                    }
                });
            },
            animatedPanTo(element, previousElement = false) {
                return new Promise(resolve => {
                    let startPos = previousElement ? this.getElementPosition(previousElement) : this.map.getPan();
                    let finalPos = this.getElementPosition(element);
                    let difference = {
                        x: finalPos.x - startPos.x,
                        y: finalPos.y - startPos.y
                    };
                    let animationTime = 400;
                    let animationStepTime = 25;
                    let animationSteps = animationTime / animationStepTime;
                    let animationStep = 0;
                    let intervalID = null;
                    let stepX = difference.x / animationSteps;
                    let stepY = difference.y / animationSteps;

                    intervalID = setInterval(() => {
                        startPos.x += stepX;
                        startPos.y += stepY;
                        if (animationStep++ < animationSteps) {
                            this.map.pan(startPos);
                        } else {
                            clearInterval(intervalID);
                            resolve();
                        }
                    }, animationStepTime);
                });
            },
            openModal() {
                if (this.isModalActive === false) {
                    this.$root.isNextCityDisabled = false;
                    this.selectedCity = this.user.mapLocation.name;
                    this.isFirstTime = !this.$root.continentTransition;
                }
                this.isModalActive = true;
            },
            resize() {
                this.isModalActive = false;
                let sidebarColumn = document.getElementsByClassName('sidebar-column')[0];
                let appHeader = document.getElementsByClassName('app-header')[0];
                if (!sidebarColumn.hidden && !appHeader.hidden) {
                    document.getElementsByClassName('main-column')[0].style.padding = '0';
                } else {
                    document.getElementsByClassName('main-column')[0].style.padding = '';
                }
                document.getElementsByClassName('app-container__body')[0].style.padding = '0';
                sidebarColumn.hidden = !sidebarColumn.hidden;
                appHeader.hidden = !appHeader.hidden;
                this.isFullScreen = !this.isFullScreen;
                this.$nextTick(() => {
                    this.tuneMap();
                    this.isModalActive = (this.isMobile && this.isFullScreen) ? this.modal : false;
                });
            },
            zoomAtLocation(location = this.user.mapLocation.name) {
                if (location === 'Introduction') {
                    this.selectedCity = location;
                    this.isModalActive = true;
                    return;
                }
                this.changeContinent(continents[location])
                    .then(() => {
                        this.isModalActive = false;
                        this.selectedCity = location === 'FINAL' ? 'Venus' : location;
                        let locationElement = document.getElementById(this.selectedCity);
                        return this.zoomTo(this.scale, locationElement);
                    })
                    .then(() => {
                        this.isModalActive = true;
                    });
            },
            resizeMap() {
                if (!this.map) {
                    this.createMap();
                    return;
                }
                if (window.innerWidth > window.innerHeight && this.map) {
                    this.$nextTick(() => {
                        this.tuneMap();
                        setTimeout(() => {
                            if (this.isMobile) {
                                !this.isFullScreen && this.resize();
                            }
                        }, 200);
                    });
                } else {
                    this.isContinentsModalShown = false;
                    this.isSubmarineShown = false;
                    this.destroyMap();
                }
            },
            tuneMap() {
                if (this.map) {
                    this.map.resize();
                    this.map.contain();
                    this.map.center();
                    this.map.fit();
                }
            },
            destroyMap() {
                this.isFullScreen && this.resize();
                if (this.map) {
                    this.map.destroy();
                    this.map = null;
                }
                this.isModalActive = false;
                this.selectedCity = null;
            },
            getElementPosition(element) {
                let sizes = this.map.getSizes();
                let cityPosition = typeof (element) === 'string' ?
                    document.getElementById(element).getBBox() : element.getBBox();
                return {
                    x: -sizes.realZoom * (cityPosition.x + cityPosition.width / 2) + sizes.width / 2,
                    y: -sizes.realZoom * (cityPosition.y + cityPosition.height / 2) + sizes.height / 2
                };
            },
            addHandlers() {
                this.selectedCity = this.user.mapLocation.name;
                this.$nextTick(() => {
                    let cityNode = null;
                    this.availableCities.forEach(city => {
                        if (continents[city] === this.continent) {
                            cityNode = document.getElementById(city);
                            if (cityNode) {
                                cityNode.onclick = () => {
                                    if (!this.isModalDisabled) {
                                        this.isModalActive = false;
                                        this.selectedCity = city;
                                        this.$nextTick(() => {
                                            this.isModalActive = true;
                                        });
                                    }
                                    this.isSetOnClickForCity = true;
                                }
                            } else {
                                this.isSetOnClickForCity = false;
                            }
                        }
                    });
                    this.continentsList.forEach(continent => {
                        document.querySelector(`#${continent}.mini-map-item`).onclick = () => {
                            this.changeContinent(continent);
                            this.isContinentsModalShown = false;
                        };
                    });
                });
            }
        },
        beforeDestroy() {
            let sidebar = document.querySelector('.sidebar-column');
            if (sidebar) {
                sidebar.classList.remove('is-hidden');
            }
            let header = document.querySelector('.app-header');
            if (header) {
                header.classList.remove('is-hidden');
            }
            let mainColumn = document.querySelector('.main-column');
            if (mainColumn) {
                mainColumn.classList.remove('is-fullscreen');
            }
            window.removeEventListener('resize', this.resizeMap, false);
            document.removeEventListener('mousedown', this.disableEvents);
            document.removeEventListener('mouseup', this.limitPan);
            if (this.map) {
                this.destroyMap();
            }
        },
        created() {
            if (this.user.type === 'olympiads-student') {
                this.$toasted.info(this.$root.$t('common.common_textInfo_pageNotAllowed'));
                this.$router.push({name: 'dashboard'});
                return;
            }
            this.changeContinent(this.continents[this.user.mapLocation.name]);
        },
        mounted() {
            if (this.user.type === 'olympiads-student') {
                return;
            }
            this.addHandlers();
            this.isMobile = !!(new MobileDetect(window.navigator.userAgent)).phone();
            this.selectedCity = this.user.mapLocation.name;
            window.addEventListener('resize', this.resizeMap, false);
            this.isFirstTime = this.user.mapLocation.name === 'Introduction' && this.user.type === 'student';
            this.isModalActive = this.user.type === 'student' &&
                (this.isMobile ? false : this.user.mapLocation.name === 'Introduction');
            this.createMap();
            if (this.video) {
                this.openFinalVideoModal();
            } else if (this.modal && !this.isFirstTime) {
                setTimeout(() => {
                    if (this.location) {
                        this.zoomAtLocation(this.location);
                    } else {
                        this.zoomAtLocation();
                    }
                }, 400);
            }
            this.isMobile && window.scrollTo(0, 1);
        }
    }
</script>

<style lang="scss">
    #map {
        background-color: lighten($hsl-color-blue-65, 10%);
    }

    .map {
        position: relative;
        flex-basis: 0;
        flex-grow: 1;
        flex-shrink: 1;
    }

    .nav-progress {
        @media screen and (max-width: 999px) {
            max-width: 350px;
        }
        @media screen and (max-width: 768px) {
            display: none;
        }
    }

    .nav-item {
        width: 100%;
    }

    .map-buttons-container {
        position: absolute;
        flex-direction: column;
        display: flex;
        padding: 1rem;
        margin-top: -1rem;
        z-index: 1;
        @media all and (orientation: portrait) {
            display: none;
        }
    }

    .map-icon {
        height: 60px;
        width: 60px;
        cursor: pointer;
        border-radius: 50%;
        background-color: $x-color-white;
        display: flex;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .2);
        margin-top: 1rem;
        @media screen and (max-width: 700px) {
            height: 45px;
            width: 45px;
        }

        &:hover {
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .4);
        }

        img {
            height: 25px;
            margin: auto;
        }

        .submarine-img {
            padding-bottom: 5px;
        }
    }


    .warning {
        display: none;
        @media all and (orientation: portrait) {
            margin-top: 10rem;
            color: $hsl-color-blue-48;
            display: block;
            font-weight: 500;
            text-align: center;
            #rotate {
                display: inline;
                fill: hsl(0, 0%, 4%);
            }
        }
    }

    .for-landscape {
        display: flex;
        height: 100%;
        width: 100%;
        @media screen and (max-width: 768px) {
            height: 100vh;
            width: 100vw;
        }
        @media screen and (min-width: 576px) and (max-width: 768px) {
            width: 95vw;
        }
        @media all and (orientation: portrait) {
            display: none;
        }
        .main-svg {
            @media screen and (max-width: 530px) {

            }
            @include media($sm) {
                border-radius: $border-radius-40;
                height: 220px;
            }
            .city-wrapper {
                &.is-invisible {
                    opacity: 0;

                    .city {
                        cursor: default;
                    }

                }

                .point {
                    opacity: 0;
                    filter: alpha(opacity=0);
                    transform: translateX(0);

                    &.show-point {
                        opacity: 1;
                        filter: alpha(opacity=100);
                        transform: translateX(0);
                        transition: all 1s ease-in-out;
                    }
                }
            }
        }
    }

    .compass {
        position: absolute;
        bottom: 18px;
        left: 6px;
        @media screen and (max-device-width: 768px) {
            position: fixed;
            bottom: 35px;
            left: 25px;
            transform: scale(0.65);
        }
    }

    .navigation-buttons {
        display: flex;
        flex-direction: column;
        position: fixed;
        right: 20px;
        top: 60%;
        @include media ($sm) {
            right: 40px;
        }
        @include media ($md) {
            top: 50%;
            right: 50px;
        }
        transform: translateY(-50%);

        .button {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-bottom: .5rem;
            border: 0;
            transition: box-shadow .1s ease-out;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .2);
            outline: none;

            .fa {
                padding-right: 0;
                padding-top: 5px;
                color: $hsl-color-green-48;
            }

            &:not(.is-disabled):hover {
                box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .4);

                .fa {
                     /*color: $info-darker;*/
                }
            }

            &.is-disabled {
                opacity: 0.4;
            }
        }
    }

    .svg-pan-zoom_viewport {
        transition: transform 0.1s ease;
    }

    .fade-enter-active, .fade-leave-active {
        opacity: 0;
    }
</style>
